import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../@types/filter";
import { AttendanceLocal } from "../../../@types/attendance-local";
import { apisiseci } from "../../api";
import { useDefaultSearchParams } from "../../../hooks/useSearchParams";
import { AxiosError } from "axios";
import { Paginated } from "../../../@types/paginated";
import { useCurrentOrgao } from "../../../hooks/useCurrentOrgao";

type Props = DefaultFilter & {
    orgao?: string;
    orgao_id?: string;
    ativo?: boolean;
};

export function useAttendanceLocalList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const currentOrgaoId = useCurrentOrgao();
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    // Adicionar filtro de órgão se disponível
    if (currentOrgaoId && !params.orgao) {
        params = { ...params, orgao_id: currentOrgaoId.toString() };
    }

    return useQuery<Paginated<AttendanceLocal>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['attendance-local', 'list', params, currentOrgaoId],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<AttendanceLocal>>(
                "/cms/unidades/",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );
            return response.data;
        },
    });
}
